import ScrollMagic from 'scrollmagic';
import { Linear, TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import 'slick-carousel';
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
const $ = window.jQuery;
const $window = window.$window || $(window);


const ParallaxComponent = {

    init () {
      var parallax = createParallax();

      function createParallax() {

        
        
        


        

        if($window.width() > 768){
          // $('#stickyTable table.body tr:first-child td').each(function(i, e){
          //   console.log(i,e);
          //   $('#stickyTable table.head tr:first-child th:eq('+i+')').css('width', ( $(this).width() / $('#stickyTable').width() ) * 100 + '%');
          // });

          
          
          // Get the table wrapper
          var $table = $("#stickyTable");
          
          // Get the offset position of the navbar
          var stickytop = $table.offset().top;
          var stickybottom = $table.offset().top + $table.height();
          
          
          // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
          

          $window.scroll(function() {
            if ($window.scrollTop() + 90 >= stickytop) {
              $table.addClass("sticky")
            } else {
              $table.removeClass("sticky");
            }
            if( $window.scrollTop() + 119 + 90 >= stickybottom){
              $table.removeClass("sticky");
              $table.addClass("stickybottom");
            }else{
              $table.removeClass("stickybottom");
            }
          });
        }
 
        $('.dismiss').on('click',function(){
          $('body').toggleClass('hide-announcement');
        });


        $('.gal').each((i,el) => {
          let $slider = $(el).find('.slick');
          $slider.slick({
            autoplay:false,
            arrows:true,
            slidesToShow: 1,
            //easing: 'easeOutElastic',
            speed: 500,
            cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
            prevArrow: $(el).find('#hps-gallery-slider .prev'),
            nextArrow: $(el).find('#hps-gallery-slider .next')
          });
          var $newel = $(el).find('.gallery-wrapper .image');
          $newel.each((i,element) => {
            $(element).on('click', (e) => {
              
              $(el).find('#hps-gallery-slider').toggleClass('active');
              $slider.slick('slickGoTo', parseInt( i ), 0);
            });
          }); 
          $(el).find('.close-gallery').on('click', () => {
            $(el).find('#hps-gallery-slider').toggleClass('active');
          });
        });

        var my_controller = new ScrollMagic.Controller({});
        new ScrollMagic.Scene({triggerElement: '.image-drawer'})
            .setClassToggle('.image-drawer', 'open')
            .addTo(my_controller);

        new ScrollMagic.Scene({triggerElement: '.image-drawer', triggerHook: 'onEnter', duration: "2000%"})
            .setClassToggle('body', 'hide-announcement')
            .addTo(my_controller);

        var my_new_controller = new ScrollMagic.Controller({});

        var my_tl = new TweenMax(".coming-soon .right-copy img", 10, { rotation: 360, repeat: -1, ease: Linear.easeNone, transformOrigin:"50% 50%"});
        new ScrollMagic.Scene({triggerHook: 0})
            .setTween(my_tl)
            .addTo(my_new_controller);
          
      //  if($window.width() > 768){
      //    $('.hero').each(function(i,el){
      //     var controller2 = new ScrollMagic.Controller();
      //     var tl = new TimelineMax();
      //     tl.to($(".lower-banner"), 1, { y: 1000, ease: Linear.easeNone });
      //     return new ScrollMagic.Scene({triggerElement: this, triggerHook: 0.4, duration: "300%"})
      //       .setTween(tl)
      //       .addTo(controller2);
           
      //    });
      //  }
    

        $('.fade-each-parent').each(function(i,el){
          var controller2 = new ScrollMagic.Controller();
          // var tl = new TimelineMax();
          // tl.to($(this).find(), 1, { y: 1000, ease: Linear.easeNone });
          return new ScrollMagic.Scene({triggerElement: this, offset: '-300%', duration: "2000%"})
            .setClassToggle(this, 'active')
            .addTo(controller2);
        });

        
      }
    
    
      $window.resize(function(){
    
        //parallax.destroy(true);
        parallax = createParallax();
      
    
      });
    
    }


};

export default ParallaxComponent;